import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.search";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import { localizeDate } from '../../utils/vuex';
import ApiService from '../../services/apiService';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import multiSearchMixin from '@/mixins/multiSearchVirtualDevices';
import healthStatusMixin from '@/components/core/virtualDevice/healthStatusMixin';
export default {
  name: 'ViewVirtualDevicesViewDetails',
  mixins: [healthStatusMixin, multiSearchMixin],
  data: function data() {
    return {
      tabItem: 'dashboard',
      viewModel: null,
      deviceTypes: [],
      accounts: [],
      virtualDeviceCount: undefined,
      alarmReportsCount: undefined,
      relatedTemplatesCount: undefined,
      firstFetch: true,
      isFetchingView: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled', 'language', 'permissions'])), mapGetters({
    tenantId: 'authentication/tenantId',
    isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
  })), {}, {
    headerBG: function headerBG() {
      var imageAttachment = get(this.viewModel, 'meta.viewImageId');

      if (imageAttachment) {
        return "".concat(process.env.VUE_APP_API_HOST).concat(process.env.VUE_APP_API_PATH, "/upload/").concat(imageAttachment);
      }

      return null;
    },
    formIsValid: function formIsValid() {
      if (this.tabItem === 'info') {
        return (this.$refs['metaEdit'] || {}).valid;
      }

      return false;
    },
    predefinedSearch: function predefinedSearch() {
      return (get(this.viewModel, 'viewConfig.searchItems') || []).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          param: item.variable,
          search: item.search
        });
      });
    },
    tableHeaders: function tableHeaders() {
      var _this = this;

      var headers = [{
        text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.tableHeaders.id'),
        value: 'id',
        sortable: true
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.tableHeaders.title'),
        value: 'title',
        sortable: true
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.tableHeaders.deviceDriverId'),
        value: 'deviceDriverInfo',
        sortable: true
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.tableHeaders.account'),
        value: 'Tenant.name',
        sortable: true
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.tableHeaders.createdAt'),
        value: 'createdAt',
        sortable: true
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.tableHeaders.updatedAt'),
        value: 'updatedAt',
        sortable: true
      }, {
        align: 'end',
        sortable: false,
        value: 'actions'
      }];

      if (this.isDeviceTemplateManager) {
        headers.push({
          text: this.$i18n_t('DeviceDriver.list.table.headers.actions'),
          isButtons: true,
          align: 'center',
          sortable: false,
          buttons: [{
            icon: 'fal fa-edit',
            color: this.color,
            onClick: function onClick(item) {
              _this.$router.push(_this.getSingleTemplateUrl(item.id));
            }
          }, {
            icon: 'fal fa-trash-alt',
            color: this.color,
            onClick: function onClick(item) {
              _this.onDeleteClick(item);
            }
          }]
        });
      }

      return headers;
    },
    isDeviceTemplateManager: function isDeviceTemplateManager() {
      return this.permissions['DeviceTemplate.manage'];
    },
    isVirtualDeviceManager: function isVirtualDeviceManager() {
      return this.permissions['VirtualDevice.manage'];
    }
  }),
  watch: {
    '$route.params.id': {
      handler: function handler(newV, oldV) {
        if (newV !== oldV) {
          this.fetchView();
        }
      }
    }
  },
  mounted: function mounted() {
    switch (this.$route.query.tab) {
      case 'info':
        this.tabItem = 'info';
        break;

      case 'virtualdevices':
        this.tabItem = 'virtualdevices';
        break;

      default:
        this.tabItem = 'dashboard';
        break;
    }

    this.fetchBridges();
    this.fetchAccounts();
    this.fetchView();
  },
  methods: {
    get: get,
    localizeDate: localizeDate,
    openMapview: function openMapview() {
      this.$router.push({
        path: '/virtual-device-groups/map',
        query: {
          view: this.$route.params.id,
          mode: 'devices'
        }
      });
    },
    getVariableText: function getVariableText(tag) {
      var tagVariable = tag.variable;
      return this.$i18n_t('DigitalTwin.VirtualDevice.props')[tagVariable] || tagVariable;
    },
    fetchAccounts: function fetchAccounts() {
      var _this2 = this;

      return this.$store.dispatch('app/loadAccounts').then(function (accounts) {
        return _this2.accounts = accounts;
      });
    },
    accountsLoaded: function accountsLoaded() {
      this.accounts = this.$store.state.app.n2Accounts.accounts;
    },
    findAccountById: function findAccountById(id) {
      return this.accounts.find(function (account) {
        return account.id === id;
      });
    },
    fetchBridges: function fetchBridges() {
      var _this3 = this;

      ApiService.getBridgeTypes().then(function (bridgeTypes) {
        _this3.bridgeTypes = bridgeTypes.filter(function (bridge) {
          // this bridge-type must have a create-functionality
          // otherwise it should have a read to get 1 single existing device as import
          if (get(bridge, 'manifest.functionScope.extension.devices.create') || get(bridge, 'manifest.functionScope.extension.devices.read')) {
            return true;
          }

          return false;
        }).map(function (bridge) {
          return bridge.manifest.displayName;
        });
      }).catch(function (error) {
        console.error(error);
      });
    },
    fetchView: function fetchView() {
      var _this4 = this;

      this.alarmReportsCount = undefined;
      this.isFetchingView = true;
      ApiService.virtualDeviceViewGet(this, this.$route.params.id).then(function (res) {
        var viewModel = _objectSpread(_objectSpread({}, res), {}, {
          account: (_this4.findAccountById(res.tenantId) || {}).name || '--'
        });

        var searchItems = get(viewModel, 'viewConfig.searchItems', []);

        if (_this4.isFeatureFlagEnabled('env_dispatcher_devicetype_fallback')) {
          // when devicetype_fallback IS enabled
          // replace deviceDriver with deviceType
          searchItems.forEach(function (item) {
            if (item.variable === 'deviceDriver') {
              item.variable = 'deviceType';
            }
          });
        } else {
          // when devicetype_fallback IS NOT enabled
          // replace deviceType to deviceDriver
          searchItems.forEach(function (item) {
            if (item.variable === 'deviceType') {
              item.variable = 'deviceDriver';
            }
          });
        }

        set(viewModel, 'viewConfig.searchItems', searchItems);
        _this4.viewModel = viewModel; // get the count of alarm-report for this group. do not care about sort-order or details

        return ApiService.fetchAlarmLogReports(_this4, 1, 1, [{
          variable: 'smartGroupId',
          search: parseInt(_this4.$route.params.id, 10)
        }], {
          variable: 'id',
          direction: 'ASC'
        });
      }).then(function (response) {
        _this4.alarmReportsCount = response.pagination.total;
      }).catch(function (e) {
        console.error('Could not fetch view', e);
      }).finally(function () {
        _this4.isFetchingView = false;
        _this4.firstFetch = false;
      });
    },
    saveView: function saveView() {
      this.$refs['metaEdit'].save();
    },
    updateViewModel: function updateViewModel(e) {
      this.viewModel = cloneDeep(e);
    },
    createAlarmReport: function createAlarmReport() {
      this.$refs['alarmreportlist'].showCreateDialog = true;
    },
    handleUpdate: function handleUpdate(options) {
      var _this5 = this;

      ApiService.virtualDeviceViewUpdate(this, options).then(function () {
        _this5.fetchView();

        _this5.$snack("".concat(_this5.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.snacks.saveGroupSuccess')), 'success');
      }).catch(function (error) {
        // ApiService.virtualDeviceViewUpdate failed
        console.error(error);
      });
    },
    closeView: function closeView() {
      this.$router.push({
        path: '/virtual-device-groups'
      });
    },
    fetchTemplates: function () {
      var _fetchTemplates = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
        var _this6 = this;

        var search, page, perPage, sortBy, sortDirection, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                search = options.search, page = options.page, perPage = options.perPage, sortBy = options.sortBy, sortDirection = options.sortDirection;
                _context.next = 3;
                return ApiService.fetchSmartGroupRelatedTemplates({
                  page: page,
                  pageSize: perPage,
                  sortBy: sortBy,
                  sortDesc: sortDirection === 'desc',
                  search: search,
                  smartGroupId: this.$route.params.id
                });

              case 3:
                result = _context.sent;
                (result.data || []).forEach(function (template) {
                  template.deviceDriverInfo = "".concat(template.devicedriver.title, " (").concat(template.deviceDriverVersion, ")");
                });
                return _context.abrupt("return", {
                  items: result.data.map(function (item) {
                    var accountName = item.tenantId;

                    if (item.account && item.account.name) {
                      accountName = item.account.name;
                    }

                    return _objectSpread(_objectSpread({}, item), {}, {
                      account: _objectSpread(_objectSpread({}, item.account), {}, {
                        name: accountName
                      }),
                      createdAt: _this6.localizeDate(item.createdAt),
                      updatedAt: _this6.localizeDate(item.updatedAt)
                    });
                  }),
                  total: result.pagination['total-count']
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchTemplates(_x) {
        return _fetchTemplates.apply(this, arguments);
      }

      return fetchTemplates;
    }(),
    getSingleTemplateUrl: function getSingleTemplateUrl(id) {
      return "/device-templates/".concat(id, "?tab=tab-device-meta");
    }
  }
};